import React, { useContext } from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import {
  FooterWrapper,
  FooterSocialWrapper,
  FooterSocialIcons,
  P,
} from '../elements';
import AppContext from '../context';

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      facebook: file(relativePath: { eq: "facebook.svg" }) {
        publicURL
      }
      github: file(relativePath: { eq: "github.svg" }) {
        publicURL
      }
      linkedin: file(relativePath: { eq: "linkedin.svg" }) {
        publicURL
      }
    }
  `);

  const { dark } = useContext(AppContext);

  return (
    <FooterWrapper>
      <FooterSocialWrapper>
        <FooterSocialIcons dark={dark}>
          <a
            href='https://www.facebook.com/anish.koulgi/'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img src={data.facebook.publicURL} alt='Facebook Logo' />
          </a>
          <a
            href='https://github.com/anishkoulgi'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img src={data.github.publicURL} alt='Github Logo' />
          </a>
          <a
            href='https://www.linkedin.com/in/anishkoulgi/'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img src={data.linkedin.publicURL} alt='Linkedin Logo' />
          </a>
        </FooterSocialIcons>
        <P size='xSmall' style={{ color: '#a8aaaa' }}>
          &#169; 2020 Anish Koulgi. All Rights Reserved
        </P>
      </FooterSocialWrapper>
    </FooterWrapper>
  );
};

export default Footer;
